import { CommonModule } from '@angular/common';
import { Component, effect, inject, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { GS1LayoutModule, GS1ModalModule } from '@gs1france/gs1-components-library';
import { TranslateModule } from '@ngx-translate/core';
import { InfoPerso } from '@models/info-perso.model';
import { HomeOurServicesComponent } from './home-our-services/home-our-services.component';
import { StorageService } from '../core/services/storage.service';
import { TagsService } from '../core/services/tags.service';
import { HomeAccountCodesComponent } from './home-account-codes/home-account-codes.component';
import { HomeWelcomeComponent } from './home-welcome/home-welcome.component';
import { HomeBannerComponent } from './home-banner/home-banner.component';
import { HomeFormationsComponent } from './home-formations/home-formations.component';
import { HomeFaqComponent } from './home-faq/home-faq.component';
import { HomeEventsComponent } from './home-events/home-events.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  imports: [
    CommonModule,
    TranslateModule,
    GS1LayoutModule,
    GS1ModalModule,
    HomeWelcomeComponent,
    HomeAccountCodesComponent,
    HomeBannerComponent,
    HomeOurServicesComponent,
    HomeFormationsComponent,
    HomeEventsComponent,
    HomeFaqComponent
  ]
})
export class HomeComponent implements OnInit {
  private storageService = inject(StorageService);
  private tagService = inject(TagsService);
  private router = inject(Router);

  user = toSignal<InfoPerso>(this.storageService.getUser());

  constructor() {
    effect(() => this.redirectUserIfFederation());
  }

  ngOnInit() {
    this.tagService.sendPage('home');
  }

  /**
   * Replaces loadUser as user is now a signal and redirection is handled reactively in effect().
   */
  redirectUserIfFederation() {
    const data = JSON.parse(this.storageService.readRaw('accountInfo'));
    if (data && (!data.privileges || data.privileges.length < 1)) {
      const isUserFederation = this.user() && this.user().roles && this.user().roles.length === 1 && this.user().roles.includes('Fédération');
      if (isUserFederation) this.router.navigate(['/standard']);
    }
  }
}
